import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import isEmpty from 'lodash/isEmpty';
import { withRouter } from 'react-router-dom';

import Scene from '../Scene';
import Container from '../../components/Container';
import Indent from '../../components/Indent';
import { crossScreenFontSize, toVw, toVwMobile, toVwTablet } from '../../utils/styles';
import Title from '../../components/Title/';
import { FONT_SIZE_BIG } from '../../constants';
import DutiesApplicant from './components/Duties/components/DutiesApplicant';
import DutiesEmployer from './components/Duties/components/DutiesEmployer';
import VacancyForm from '../../components/VacancyForm';
import mq from '@/utils/media-queries';
import Media from '../../components/Media';
import api from '../../utils/api';
import responseIs404 from '../../utils/responseIs404';
import NotFound from '../NotFound';
import AnimationOnPageLoadItem from '../../components/AnimationOnPageLoadItem';

const SCENE_PADDING_TOP = 265;

const VacancyScene = styled(Scene)`
  padding-top: ${toVw(SCENE_PADDING_TOP)};
  padding-bottom: ${toVw(276)};

  ${mq.tablet(css`
    padding-top: ${toVwTablet(SCENE_PADDING_TOP)};
    padding-bottom: ${toVwTablet(578)};
  `)};

  ${mq.mobile(css`
    padding-top: ${toVwMobile(277)};
    padding-bottom: ${toVwMobile(255)};
  `)};
`;

const TITLE_MARGIN_BOTTOM = 80;

const StyledTitle = styled(Title)`
  margin-bottom: ${toVw(TITLE_MARGIN_BOTTOM)};

  ${mq.tablet(css`
    margin-bottom: ${toVwTablet(TITLE_MARGIN_BOTTOM)};
  `)};

  ${mq.mobile(css`
    margin-bottom: ${toVwMobile(113)};
  `)};
`;

const LOCATION_MARGIN_BOTTOM = 102;

const Location = styled.div`
  color: ${props => props.theme.colorMinor};
  margin-bottom: ${toVw(LOCATION_MARGIN_BOTTOM)};

  ${mq.tablet(css`
    margin-bottom: ${toVwTablet(LOCATION_MARGIN_BOTTOM)};
  `)};

  ${mq.mobile(css`
    margin-bottom: ${toVwMobile(LOCATION_MARGIN_BOTTOM)};
  `)};
`;

const PHOTO_MARGIN_BOTTOM = 144;

const Photo = styled(Media)`
  margin-bottom: ${toVw(PHOTO_MARGIN_BOTTOM)};

  ${mq.tablet(css`
    margin-bottom: ${toVwTablet(PHOTO_MARGIN_BOTTOM)};
  `)};

  ${mq.mobile(css`
    margin-bottom: ${toVwMobile(PHOTO_MARGIN_BOTTOM)};
  `)};
`;

const DESCRIPTION_MARGIN_BOTTOM = 130;

const Description = styled.div`
  ${crossScreenFontSize(FONT_SIZE_BIG)};
  margin-bottom: ${toVw(DESCRIPTION_MARGIN_BOTTOM)};

  p {
    margin-bottom: ${toVw(60)};

    &:last-child {
      margin-bottom: 0;
    }
  }

  ${mq.tablet(css`
    margin-bottom: ${toVwTablet(DESCRIPTION_MARGIN_BOTTOM)};
  `)};

  ${mq.mobile(css`
    margin-bottom: ${toVwMobile(110)};
    font-size: ${toVwMobile(44)};
  `)};
`;

const DUTIES_APPLICANT_MARGIN_BOTTOM = 129;

const StyledDutiesApplicant = styled(DutiesApplicant)`
  margin-bottom: ${toVw(DUTIES_APPLICANT_MARGIN_BOTTOM)};

  ${mq.tablet(css`
    margin-bottom: ${toVwTablet(DUTIES_APPLICANT_MARGIN_BOTTOM)};
  `)};

  ${mq.mobile(css`
    margin-bottom: ${toVwMobile(115)};
  `)};
`;

const DUTIES_EMPLOYER_MARGIN_BOTTOM = 175;

const StyledDutiesEmployer = styled(DutiesEmployer)`
  margin-bottom: ${toVw(DUTIES_EMPLOYER_MARGIN_BOTTOM)};

  ${mq.tablet(css`
    margin-bottom: ${toVwTablet(DUTIES_EMPLOYER_MARGIN_BOTTOM)};
  `)};

  ${mq.mobile(css`
    margin-bottom: ${toVwMobile(DUTIES_EMPLOYER_MARGIN_BOTTOM)};
  `)};
`;

class Vacancy extends React.Component {
  static propTypes = {
    match: PropTypes.object.isRequired,
  };

  state = {
    entity: {},
    notFound: false,
  };

  componentDidMount() {
    const id = this.props.match.params.id;
    this.load(id);
  }

  load = async id => {
    const response = await api.vacancy(id);
    const data = await response.json();
    if (responseIs404(response)) {
      this.setState({ notFound: true });
      return;
    }
    this.setState({ entity: { ...data } });
  };

  render() {
    if (this.state.notFound) {
      return <NotFound />;
    }

    const { title, location, photo, description, dutiesApplicant, dutiesEmployer } = this.state.entity;

    const {
      match: {
        params: { id: vacancyId },
      },
      ...rest
    } = this.props;

    return (
      <VacancyScene {...rest}>
        <Container>
          <Indent>
            <AnimationOnPageLoadItem>
              <React.Fragment>
                <StyledTitle html={title} />
                <Location>{location}</Location>
              </React.Fragment>
            </AnimationOnPageLoadItem>
          </Indent>
          {photo && photo.content && <Photo {...photo} />}
          <Indent>
            <Description dangerouslySetInnerHTML={{ __html: description }} />
            {dutiesApplicant && !isEmpty(dutiesApplicant) && <StyledDutiesApplicant duties={dutiesApplicant} />}
            {dutiesEmployer && !isEmpty(dutiesEmployer) && <StyledDutiesEmployer duties={dutiesEmployer} />}
            <VacancyForm vacancyId={vacancyId} />
          </Indent>
        </Container>
      </VacancyScene>
    );
  }
}

export default withRouter(Vacancy);



// WEBPACK FOOTER //
// ./src/scenes/Vacancy/index.js